import { OFFLINE_GAMES_ENABLED } from "./featureEnabled";
import { useEffect } from "react";
import { hasOfflineGames } from "./registry";
import { isOfflinePlaySupported, refreshOfflineSite, registerOfflineServiceWorker, retireOfflineServiceWorker, syncOfflineProgress } from "./serviceWorker";

// For users with downloaded games: keep the offline worker registered, cache
// each new site build, and sync offline progress whenever the network is back.
const useOfflineGamesLifecycle = () => {
	useEffect(() => {
		if (!OFFLINE_GAMES_ENABLED) {
			retireOfflineServiceWorker().catch(error => console.warn("[Offline] retirement failed:", error?.message));
			return undefined;
		}
		if (!isOfflinePlaySupported() || !hasOfflineGames()) return undefined;
		let cancelled = false;

		const syncAndRefresh = () => {
			if (cancelled || !navigator.onLine) return;
			syncOfflineProgress().catch((error) => console.warn("[Offline] sync failed:", error?.message));
			refreshOfflineSite().catch((error) => console.warn("[Offline] site cache refresh failed:", error?.message));
		};

		registerOfflineServiceWorker()
			.then(syncAndRefresh)
			.catch((error) => console.warn("[Offline] service worker registration failed:", error?.message));
		window.addEventListener("online", syncAndRefresh);
		return () => {
			cancelled = true;
			window.removeEventListener("online", syncAndRefresh);
		};
	}, []);
};

export default useOfflineGamesLifecycle;
